import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import theme from "../../assets/images/signup.png";
import theme from "../../assets/images/login_img_new.png";
import logo from "../../assets/images/logo.png";
import { AuthService, UserSignUpData } from "services/AuthService";
import {
  readShopifyOnboardingSession,
  shopifySignInPath,
} from "services/ShopifyOnboardingSession";
import {
  readWooOnboardingSession,
  wooSignInPath,
} from "services/WooCommerceOnboardingSession";
import { toast } from "react-toastify";
toast.configure();
import "react-toastify/dist/ReactToastify.css";
import { RequestState } from "enum/RequestState";
import { Radio } from "antd";
import Copyright from "components/Common/copyright";
import { RouteContext } from "context/RouteProvider";
import { useNavigate } from "react-router-dom";
import { geocodeByPlaceId } from "react-google-places-autocomplete";
import { AddressModel } from "models/City";
import { environment } from "environment/environment";
import CustomGooglePlacesAutocomplete from "components/Common/auto-complete";
import { AddressType } from "enum/AddressType";

const Signup: React.FC = () => {
  const [disabledBtn, setDesableBtn] = useState<boolean>(false);
  const [loginRequestState, setLoginRequestState] = useState<RequestState>(RequestState.INITIAL);
  const [isProtected, setIsProtected] = useContext(RouteContext);
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [userName, setuserName] = useState<string>("");
  const [isABusiness, setIsABusiness] = useState<boolean>(false);
  const [address, setAddress] = useState<AddressModel>({} as AddressModel);
  const [unitNo, setUnitNo] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [confirm, setConfirm] = useState<string>("");
  const [businessName, setBusinessName] = useState<string>("");
  const [isChecked, setIsChecked] = useState<boolean>(false);

  const [firstNameErr, setFirstNameErr] = useState<string>();
  const [lastNameErr, setLastNameErr] = useState<string>();
  const [userNameErr, setUserNameErr] = useState<string>();
  const [addressErr, setAddressErr] = useState<string>();
  const [emailErr, setEmailErr] = useState<string>();
  const [phoneErr, setPhoneErr] = useState<string>();
  const [passwordErr, setPasswordErr] = useState<string>();
  const [confirmErr, setConfirmErr] = useState<string>();
  const [businessNameErr, setBusinessNameErr] = useState<string>();
  const [isCheckedErr, setIsCheckedErr] = useState<string>();
  const canadianPhoneRegExp = /^(?:(?:\+1|1-)?(?:\(\d{3}\)|\d{3})[-.]\d{3}[-.]\d{4}|(?:\+1|1-)?\d{10})$/;
  const navigate = useNavigate();
  const mapprops: any = {
    componentRestrictions: { country: "ca" },
    locationRestriction: {
      north: 56.85,    // Northeast corner latitude (Keep this as is)
      south: 41.6,     // Southwest corner latitude (Keep this as is)
      east: -74.0,     // Adjusted Northeast corner longitude to cover Kingston and Cornwall
      west: -95.15     // Keep this as is to cover the entire Ontario province
    }
  };

  useEffect(() => {
    const session = readShopifyOnboardingSession() || readWooOnboardingSession();
    if (session) {
      setIsABusiness(true);
    }
  }, []);

  const onSubmit = (actions: any) => {
    const updatedAddress = {
      ...address,
      contactName: `${firstName} ${lastName}`,
      contactPhone: phone,
      unit: unitNo,
      companyName: businessName,
    };
  
    setAddress(updatedAddress);
  
    const data: UserSignUpData = {
      firstName,
      lastName,
      email,
      userName,
      password,
      businessName,
      isABusiness,
      address: updatedAddress,
      phoneNumber: phone,
    };
  
    const isValid: boolean = validateForm(data);
  
    if (isValid) {
      setDesableBtn(true); 
  
      AuthService.userSignup(data)
        .then((res) => {
          if (res.success) {
            setLoginRequestState(RequestState.SUCCESS);
            setIsProtected(true);
            navigate("/email-verification", { state: { email: res.data } });
          } else {
            setLoginRequestState(RequestState.FAILED);
            toast.error(res.error, {
              position: toast.POSITION.BOTTOM_RIGHT,
              className: "foo-bar",
              style: { marginBottom: "4rem" },
            });
          }
        })
        .catch(() => {
          setLoginRequestState(RequestState.FAILED);
        })
        .finally(() => {
          setDesableBtn(false);
        });
    }
  };

  const handleChange = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;

    switch (name) {
      case "firstName":
        if (value == "" || value == undefined || value == null) {
          setFirstNameErr("Required");
        } else if (!/^[a-zA-Z\s]*$/.test(value)) {
          setFirstNameErr("Only letters are allowed!");
        } else {
          setFirstNameErr(undefined);
        }
        setFirstName(value);
        break;
      case "lastName":
        if (value == "" || value == undefined || value == null) {
          setLastNameErr("Required");
        } else if (!/^[a-zA-Z\s]*$/.test(value)) {
          setLastNameErr("Only letters are allowed!");
        } else {
          setLastNameErr(undefined);
        }
        setLastName(value);
        break;
      case "userName":
          if (value == "" || value == undefined || value == null) {
            setUserNameErr("Required");
          } else if (!/^[a-zA-Z0-9\s]+$/.test(value)) {
            setUserNameErr("Only letters and numbers are allowed!");
          } else {
            setUserNameErr(undefined);
          }
          setuserName(value);
          break;
      case "isBusiness":
        setIsABusiness(value === "yes" ? true : false);
        break;
      case "businessName":
        if (isABusiness) {
          if (value == "" || value == undefined || value == null) {
            setBusinessNameErr("Required");
          } else {
            setBusinessNameErr(undefined);
          }
          setBusinessName(value);
        }
        break;
      case "unitNo":
        setUnitNo(value);
        break;
      case "email":
        if (value == "" || value == undefined || value == null) {
          setEmailErr("Required");
        } else if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value)) {
          setEmailErr("Invalid email");
        } else {
          setEmailErr(undefined);
        }
        setEmail(value);
        break;
      case "phone":
        if (value == "" || value == null || value == undefined) {
          setPhoneErr("Required");
        } else if (!canadianPhoneRegExp.test(value)) {
          setPhoneErr("Invalid Canadian phone number");
        } else {
          setPhoneErr(undefined);
        }
        setPhone(value);
        break;
      case "password":
        if (value == "" || value == null || value == undefined) {
          setPasswordErr("Required");
        } else if (value.length < 6) {
          setPasswordErr("Password should be atleast 6 characters long.");
        } else {
          setPasswordErr(undefined);
        }
        setPassword(value);
        break;
      case "confirm":
        if (value == "" || value == null || value == undefined) {
          setConfirmErr("Required");
        } else if (value.length < 6) {
          setConfirmErr("Password should be atleast 6 characters long.");
        } else if (password !== value) {
          setConfirmErr("Password should match.");
        } else {
          setConfirmErr(undefined);
        }
        setConfirm(value);
        break;
      case "isChecked":
        if (value == false) {
          setIsCheckedErr("Required");
        } else {
          setIsCheckedErr(undefined);
        }
        setAddress({ ...address, contactName: `${firstName} ${lastName}`, contactPhone: phone, unit: unitNo, companyName: businessName });
        setIsChecked(!isChecked);
        break;

      default:
        break;
    }
  };

  const validateForm = (data: UserSignUpData) => {
    let isValid = true;

    // Reset all errors before validation
    setFirstNameErr("");
    setLastNameErr("");
    setUserNameErr("");
    setAddressErr("");
    setEmailErr("");
    setPhoneErr("");
    setPasswordErr("");
    setConfirmErr("");
    setIsCheckedErr("");

    if (!data.firstName?.trim()) {
      setFirstNameErr("Required");
      isValid = false;
    } else if (!/^[a-zA-Z\s]+$/.test(data.firstName)) {
      setFirstNameErr("Only letters are allowed!");
      isValid = false;
    }

    if (!data.lastName?.trim()) {
      setLastNameErr("Required");
      isValid = false;
    } else if (!/^[a-zA-Z\s]+$/.test(data.lastName)) {
      setLastNameErr("Only letters are allowed!");
      isValid = false;
    }

    if (!data.userName?.trim()) {
      setUserNameErr("Required");
      isValid = false;
    } else if (!/^[a-zA-Z0-9]+$/.test(data.userName)) {
      setUserNameErr("Only letters and numbers are allowed!");
      isValid = false;
    } else if (data.userName.length < 3) {
      setUserNameErr("User Name should be at least 3 characters long.");
      isValid = false;
    }

    if (!data.address?.city?.trim()) {
      setAddressErr("City is required");
      isValid = false;
    }

    if (!data.email?.trim()) {
      setEmailErr("Required");
      isValid = false;
    } else if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(data.email)) {
      setEmailErr("Invalid email format");
      isValid = false;
    }

    if (!data.phoneNumber?.trim()) {
      setPhoneErr("Required");
      isValid = false;
    } else if (!canadianPhoneRegExp.test(data.phoneNumber)) {
      setPhoneErr("Invalid Canadian phone number");
      isValid = false;
    }

              if (!data.password?.trim()) {
      setPasswordErr("Required");
      isValid = false;
    } else if (data.password.length < 6) {
      setPasswordErr("Password should be at least 6 characters long.");
      isValid = false;
    }

    if (!confirm?.trim()) {
      setConfirmErr("Required");
      isValid = false;
    } else if (confirm !== data.password) {
      setConfirmErr("Passwords do not match.");
      isValid = false;
    }

    if (!isChecked) {
      setIsCheckedErr("Please read and agree to the terms and conditions.");
      isValid = false;
    }

    return isValid;
  };  

  const handleAddress = async (label: string, place_id: string, type: string) => {
    if (!place_id) {
      setAddress({ city: "", lat: undefined, lng: undefined, postalCode: "" }); 
      return;
    }
    
    if (place_id !== "") {
    const address = label;
    await geocodeByPlaceId(place_id).then(([place]: google.maps.GeocoderResult[]) => {
    const { long_name: postalCode = "" } = place.address_components.find(c => c.types.includes("postal_code")) || {};
    const latLng = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
      };
    setAddress({ city: address, lat:latLng.lat, lng:latLng.lng, postalCode: postalCode });
    }).catch(err => {
      console.log(err);
    });
    }
  };

  document.title = "Signup | Zulu Courier ";

  return (
    <div className="container">
      <section className="my-4">
        <div className="position-relative">
          <div className="row g-5 w-100">
            <div className="col-lg-7 col-md-12 col-sm-12 d-inline align-items-center justify-content-center">
              <img src={theme} alt="" className="w-100 position-relative" />
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12 d-inline">
              <div className="px-4 py-5">
                <div className="sign-logo mb-3">
                  <a href={`${environment.app_url}/home`}>
                    <img src={logo} alt="" />
                  </a>
                </div>
                <h3 className="title mb-1 text-black">Customer Registration</h3>
                <p className="mb-4">
                  Already have an account? <Link to={readWooOnboardingSession() ? wooSignInPath() : shopifySignInPath()}>Log in now</Link>
                </p>
                <div className="form-group">
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 mt-2">
                      <label className="place-order-title">
                        First Name <span className="text-danger">*</span>
                      </label>
                      <input
                        value={firstName}
                        onChange={handleChange}
                        name="firstName"
                        type="text"
                        placeholder=""
                        className={firstNameErr ? "input-error form-control" : "form-control"}
                      />
                      {firstNameErr !== undefined && <small className="error col-lg-5 place-order-title">{firstNameErr}</small>}
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mt-2">
                      <div className="row">
                        <label className="place-order-title">
                          Last Name <span className="text-danger">*</span>
                        </label>
                      </div>
                      <input
                        value={lastName}
                        onChange={handleChange}
                        name="lastName"
                        type="text"
                        placeholder=""
                        className={lastName ? "input-error form-control" : "form-control"}
                      />
                      {lastNameErr && <small className="error  place-order-title">{lastNameErr}</small>}
                    </div>
                  </div>
                </div>

                <div className="row mt-2">
                  <div className="col-lg-12">
                    <label className="place-order-title me-4">Customer Category?</label>
                    <Radio.Group value={isABusiness ? "yes" : "no"} onChange={handleChange} name="isBusiness">
                      <Radio value="yes">Business</Radio>
                      <Radio value="no">Personal</Radio>
                    </Radio.Group>
                  </div>
                  {isABusiness == true && (
                    <div className="form-group">
                      <label className="place-order-title">
                        Business Name<label className="title-star">*</label>
                      </label>
                      <input
                        value={businessName}
                        onChange={handleChange}
                        name="businessName"
                        type="text"
                        placeholder=""
                        className={businessNameErr ? "input-error form-control" : "form-control"}
                      />
                      {businessNameErr && <small className="error place-order-title">{businessNameErr}</small>}
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <label className="place-order-title">
                    Address <span className="text-danger">*</span>
                  </label>
                  <CustomGooglePlacesAutocomplete
                    apiKey={environment.google_maps_key}
                    autocompletionRequest={mapprops}
                    addressType={AddressType.pickup}
                    selectProps={{
                      name: "address",
                    }}
                    handleAddress={handleAddress}
                  />
                  {addressErr && <small className="error col-lg-5 place-order-title">{addressErr}</small>}
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <label className="place-order-title pb-2">
                        Unit No <label className="py-1"></label>
                      </label>
                      <input
                        value={unitNo}
                        onChange={handleChange}
                        name="unitNo"
                        type="text"
                        placeholder=""
                        className="form-control"
                      />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mt-2">
                      <label className="place-order-title">
                        Phone Number <span className="text-danger">*</span>
                      </label>
                      <input
                        value={phone}
                        onChange={handleChange}
                        name="phone"
                        type="text"
                        placeholder=""
                        className={phoneErr ? "input-error form-control" : "form-control"}
                      />
                      {phoneErr && <small className="error place-order-title">{phoneErr}</small>}
                    </div>
                  </div>
                </div>


                <div className="form-group mt-2">
                  <label className="place-order-title">
                    Email <span className="text-danger">*</span>
                  </label>
                  <input
                    value={email}
                    onChange={handleChange}
                    name="email"
                    type="text"
                    placeholder=""
                    className={emailErr ? "input-error form-control" : "form-control"}
                  />
                  {emailErr && <small className="error place-order-title">{emailErr}</small>}
                </div>

                <div className="form-group mt-2">
                  <label className="place-order-title">
                    User Name <span className="text-danger">*</span>
                  </label>
                  <input
                    value={userName}
                    onChange={handleChange}
                    name="userName"
                    type="text"
                    placeholder=""
                    className={userNameErr ? "input-error form-control" : "form-control"}
                  />
                  {userNameErr && <small className="error place-order-title">{userNameErr}</small>}
                </div>

                <div className="form-group ">
                  <div className="row">
                    <div className="col-lg-6 mt-2 col-md-6 col-sm-12 mt-2">
                      <label className="place-order-title">
                        Create Password<label className="title-star"></label>
                      </label>
                      <input
                        value={password}
                        onChange={handleChange}
                        name="password"
                        type="password"
                        placeholder=""
                        className={passwordErr ? "input-error form-control" : "form-control"}
                      />
                      {passwordErr && <p className="error  place-order-title">{passwordErr}</p>}
                      <span className="password-show">
                        <i className="icon-76"></i>
                      </span>
                    </div>
                    <div className="col-lg-6 mt-2 col-md-6 col-sm-12 mt-2">
                      <label className="place-order-title">
                        Confirm Password<label className="title-star"></label>
                      </label>
                      <input
                        value={confirm}
                        onChange={handleChange}
                        name="confirm"
                        type="password"
                        placeholder=""
                        className={confirmErr ? "input-error form-control" : "form-control"}
                      />
                      {confirmErr && <small className="error place-order-title">{confirmErr}</small>}
                    </div>
                  </div>
                </div>

                <div className="form-group mt-2">
                  <div className="row">
                    <div className="col-lg-12">
                      <input checked={isChecked} name="isChecked" type="checkbox" onChange={handleChange} />
                      <label className="place-order-title mx-2">
                        By Clicking Sign up, you agree to our <a href="/terms-of-service" target="_blank">terms and conditions</a>
                      </label>
                    </div>
                    {isCheckedErr && <small className="error place-order-title">{isCheckedErr}</small>}
                  </div>
                </div>

                <div className="form-group mt-2">
                  <button type="submit" disabled={disabledBtn} className="btn btn-md bg-orange text-white w-100 button-bg" onClick={onSubmit}>
                    Register
                  </button>
                </div>

                <div className="w-100 text-center mt-5">
                  <Copyright />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Signup;
